import React, { useState, useEffect } from "react";
import SearchInput from "../search/SearchInput";
import ActionButton from "../Button/ActionButton";
import "./Reports.scss";
import TimeFilter from "../Filter/TimeFilter/TimeFilter";
import DateRangeBadge from "../DateRangeBadge/DateRangeBadge";

const TODAY = new Date();

const initialMonthRange = {
  from: { year: 2015, month: 0 },
  to: { year: TODAY.getFullYear(), month: TODAY.getMonth() },
};

const getDateFromString = (
  yearMonth,
  firstDate = false,
  referenceDate = new Date(),
) => {
  if (!yearMonth) return null;

  const [yearStr, monthStr] = yearMonth.split("-");

  const year = Number(yearStr);
  const month = Number(monthStr);

  const isCurrentMonth =
    year === referenceDate.getFullYear() && month === referenceDate.getMonth();

  let date;

  if (firstDate) {
    // 🔹 Always first date
    date = new Date(year, month, 1);
  } else {
    // 🔹 Last date OR today if current month
    date = isCurrentMonth ? referenceDate : new Date(year, month + 1, 0);
  }

  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd}`;
};

const timeOptions = [
  { label: "All time", value: "all_time" },
  { label: "Custom month range", value: "custom" },
];

const fileTypeOption = [
  { label: ".xlsx", value: "xlsx" },
  // { label: ".xlsx", value: "excel" },
  { label: ".csv", value: "csv" },
  { label: ".tsv", value: "tsv" },
  // { label: ".json", value: "json" },
];

const isValidEmail = (email) => {
  if (typeof email !== "string") return false;

  const value = email.trim();

  if (!value) return false;

  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return regex.test(value);
};

const ReportExportOptions = ({
  handleExportReport,
  width = "half",
  handleClose = () => {},
  showTimeFilter = true,
  showFileType = true,
}) => {
  const [startDate, setStartDate] = useState({ year: 2015, month: 0 });
  const [timeRange, setTimeRange] = useState(timeOptions[0].value);
  const [isMonthPickerOpen, setIsMonthPickerOpen] = useState(false);
  const [showDateRangeBadge, setShowDateRangeBadge] = useState(false);
  const [monthRange, setMonthRange] = useState(initialMonthRange);
  const [query, setQuery] = useState({
    email: "",
    format: "xlsx",
    startDate: "",
    endDate: "",
  });

  useEffect(() => {
    //SELECT ALL TIME
    if (timeRange?.value === timeOptions[0].value) {
      setShowDateRangeBadge(false);
      setQuery((prev) => ({ ...prev, startDate: "", endDate: "" }));
    }
  }, [timeRange]);

  return (
    <div
      className={` px-0  ms-0 ${width === "full" ? "w-100" : "w-50"} report-details-container`}
    >
      <div className="report-details d-flex flex-column gap-4">
        {showFileType && (
          <div className="">
            <label>File Type</label>
            <div className="radio-group">
              {fileTypeOption.map((item, index) => (
                <label key={index} className="me-3">
                  <input
                    type="radio"
                    name="fileType"
                    value={item.value}
                    className="form-check-input"
                    checked={query.format === item.value}
                    // disabled={item.value === "excel" ? false : true}
                    onChange={(e) => {
                      const value = e.target.value;
                      setQuery((prev) => ({
                        ...prev,
                        format: value,
                      }));
                    }}
                  />{" "}
                  {item.label}
                </label>
              ))}
            </div>
          </div>
        )}

        <div className="mt-2">
          <div className="position-relative g-2">
            {showTimeFilter && (
              <TimeFilter
                label=""
                startDate={startDate}
                filterValue={timeRange}
                options={timeOptions}
                selectedValue={timeRange}
                onChange={setTimeRange}
                open={isMonthPickerOpen}
                monthRangeValue={monthRange}
                // disabled={true}
                onApply={(range) => {
                  setQuery((prev) => ({
                    ...prev,
                    startDate: `${range.from.year}-${range.from.month < 10 ? `0${range.from.month}` : range.from.month}`,
                    endDate: `${range.to.year}-${range.to.month < 10 ? `0${range.to.month}` : range.to.month}`,
                  }));
                  setMonthRange(range);
                  setShowDateRangeBadge(true);
                  setIsMonthPickerOpen(false);
                }}
                onCancel={() => {
                  setIsMonthPickerOpen(false);
                  setTimeRange("all_time");
                }}
                width="full"
              />
            )}

            {showTimeFilter && showDateRangeBadge && (
              <div className="mt-1">
                <DateRangeBadge
                  range={monthRange}
                  setTimeRange={setTimeRange}
                  setShowDateRangeBadge={setShowDateRangeBadge}
                  timeOptions={timeOptions}
                />
              </div>
            )}
          </div>
        </div>

        <div className="">
          <label>Email Address</label>
          <SearchInput
            placeholder="Enter your email address"
            showIcon={false}
            selectedSearchValue={query.email}
            onChange={(value) =>
              setQuery((prev) => ({ ...prev, email: value }))
            }
          />
        </div>

        {/* <ActionButton label="Export Report" onClick={handleExportReport} /> */}
        <div className="">
          <button
            className={`export-report btn btn-custom w-100 text-nowrap`}
            onClick={() => {
              handleExportReport({
                ...query,
                startDate: getDateFromString(query.startDate, true),
                endDate: getDateFromString(query.endDate),
              });
              handleClose();
              setMonthRange(initialMonthRange);
              setShowDateRangeBadge(false);
              setTimeRange("all_time");
              setQuery({
                email: "",
                format: "xlsx",
                startDate: "",
                endDate: "",
              });
            }}
            disabled={isValidEmail(query.email) ? false : true}
          >
            Export Report
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportExportOptions;
